<div *ngIf="canAccess" class="p-4 bg-gray-opacity2 rounded-2xl mt-8 flex items-center justify-center flex-col">
  <img width="64px" class="rounded-full" src="./assets/icons/profile-icon.svg" />
  <div class="w-full max-w-2xl flex flex-col">
    <!-- Información Personal -->
    <div class="mb-6">
      <h3 class="text-lg font-semibold text-gray-800 mb-3 text-center">Información Personal</h3>
      <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div class="flex flex-col">
          <span class="text-sm text-gray-500">Nombre</span>
          <span class="text-base font-medium">{{ !name ? phone_number : name }}</span>
        </div>
        <div class="flex flex-col">
          <span class="text-sm text-gray-500">Teléfono</span>
          <div class="flex items-center gap-2">
            <span class="text-base font-medium">{{ !name ? '' : phone_number }}</span>
            <ng-container *ngIf="signalwire_verified_phone_number; then verified else notVerified"></ng-container>
            <ng-template #verified>
              <mat-chip color="secondary" class="text-xs">{{ 'COMPONENTS.PROFILE.MY_PROFILE.VERIFIED' | translate }}</mat-chip>
            </ng-template>
            <ng-template #notVerified>
              <mat-chip class="text-xs">{{ 'COMPONENTS.PROFILE.MY_PROFILE.NOT_VERIFIED' | translate }}</mat-chip>
            </ng-template>
          </div>
        </div>
        <div class="flex flex-col">
          <span class="text-sm text-gray-500">Email</span>
          <span class="text-base font-medium">{{ email || ('BTB.NOT_SET' | translate) }}</span>
        </div>
      </div>
    </div>

    <!-- Información del Partner -->
    <div class="mb-6">
      <h3 class="text-lg font-semibold text-gray-800 mb-3 text-center">Información del Partner</h3>
      <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div class="flex flex-col">
          <span class="text-sm text-gray-500">{{ 'BTB.PARTNER_ID' | translate }}</span>
          <span class="text-base font-medium">{{ partnerId || ('BTB.NOT_SET' | translate) }}</span>
        </div>
        <div class="flex flex-col">
          <span class="text-sm text-gray-500">{{ 'BTB.PARTNER_TYPE' | translate }}</span>
          <span class="text-base font-medium">{{ partnerType || ('BTB.NOT_SET' | translate) }}</span>
        </div>
      </div>
    </div>

    <!-- Información del Negocio -->
    <div class="mb-6">
      <h3 class="text-lg font-semibold text-gray-800 mb-3 text-center">Información del Negocio</h3>
      <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div class="flex flex-col">
          <span class="text-sm text-gray-500">{{ 'BTB.BUSINESS_NAME' | translate }}</span>
          <span class="text-base font-medium">{{ businessName || ('BTB.NOT_SET' | translate) }}</span>
        </div>
        <div class="flex flex-col">
          <span class="text-sm text-gray-500">{{ 'BTB.BUSINESS_DESCRIPTION' | translate }}</span>
          <span class="text-base font-medium">{{ businessDescription || ('BTB.NOT_SET' | translate) }}</span>
        </div>
        <div class="flex flex-col">
          <span class="text-sm text-gray-500">{{ 'COMPONENTS.PROFILE.MY_PROFILE.EDIT_PROFILE.BANK_ACCOUNT' | translate }}</span>
          <span class="text-base font-medium">{{ bankAccount || ('BTB.NOT_SET' | translate) }}</span>
        </div>
      </div>
    </div>
    <mat-divider></mat-divider>
    <div class="flex flex-row mt-8 mb-8 w-full justify-evenly md:justify-center md:gap-16">
      <div class="flex flex-col items-center gap-2">
        <button
          routerLink="edit"
          class="text-black font-bold py-2 px-4 rounded hover:bg-gray-200 transition flex items-center justify-center">
          <img src="./assets/icons/edit-profile.svg" alt="Edit Profile" />
        </button>
        <div class="text-gray text-base text-center">
          {{ 'COMPONENTS.PROFILE.MY_PROFILE.EDIT' | translate }}
        </div>
      </div>
      <div *ngIf="!signalwire_verified_phone_number && phone_number" class="flex flex-col items-center gap-2">
        <button
          (click)="openVerification()"
          [disabled]="isVerificationInProgress"
          class="text-black font-bold py-2 px-4 rounded disabled:bg-gray-400 hover:bg-gray-200 transition">
          <img src="./assets/icons/my-profile-change-password.svg" alt="Verify" />
        </button>
        <div class="text-gray text-base text-center">
          {{ 'COMPONENTS.PROFILE.MY_PROFILE.VERIFY_MY_NUMBER.TITLE' | translate }}
        </div>
      </div>
      <!--<div class="flex flex-col items-center gap-2">
        <button
          (click)="openModal()"
          [disabled]="isVerificationInProgress"
          class="text-black font-bold py-2 px-4 rounded disabled:bg-gray-400 hover:bg-gray-200 transition">
          <img src="./assets/icons/my-profile-trash.svg" />
        </button>
        <div class="text-gray text-base text-center">
          {{ 'COMPONENTS.PROFILE.MY_PROFILE.DELETE' | translate }}
        </div>
      </div>-->
    </div>
    <!--<mat-divider></mat-divider>
    <div class="my-8">
      <div class="flex flex-row justify-between w-full">
        <img class="relative rotate-minus12" width="147px" src="./assets/icons/card.svg" alt="card" />
        <p class="flex flex-col mb-2 mt-4 mr-2 tracking-tight text-gray items-end">
          {{ 'COMPONENTS.HEADER.BALANCE' | translate }}
          <span class="text-light-red text-2xl items-end text-right">
            {{ balance | currency : currency : 'symbol' }}
          </span>
          <a class="text-sm text-light-red" routerLink="/recharges">{{
            'COMPONENTS.HEADER.ADD' | translate
            }}</a>
        </p>
      </div>
    </div>-->
  </div>
  <div>
    <button mat-button color="primary" (click)="goBack()">Volver</button>
  </div>
</div>
